// extracted by mini-css-extract-plugin
export var circle = "_dm-1";
export var exitConfirmationModal = "_dm-5";
export var iframe = "_dm-0";
export var offline = "_dm-3";
export var online = "_dm-2";
export var workstationSelectError = "_dm-4";